export interface LegacyFeatureFlags {
  useContentfulV2: boolean;
}

/*
Flags defined here MUST match their definition in backend's FeatureFlags enum.
See "Feature Flags" section in the README.md for details.
 */
export interface DatadogFeatureFlags {
  is_profile_prefill_enabled: boolean;
  is_footer_test_enabled: boolean;
  is_skip_income_enabled: boolean;
  is_rue_landing_page_enabled: boolean;
  is_hide_eligibility_questions_enabled: boolean;
  is_educational_videos_enabled: boolean;
  is_cancer_insurance_enabled: boolean;
  is_profile_review_tool_enabled: boolean;
  is_no_deductible_plans_enabled: boolean;
  is_ulp_updates_enabled: boolean;
  is_go_teladoc_mtm_enabled: boolean;
  is_usersnap_enabled: boolean;
  is_go_talkspace_mtm_enabled: boolean;
  is_election_members_enabled: boolean;
  is_incentives_shortcut_enabled: boolean;
  is_life_ltc_enabled?: boolean;
  is_medicare_content?: boolean;
  is_legacy_health_text_note_fallback_enabled?: boolean;
  is_hsa_funds_question_enabled?: boolean;
  is_send_hsa_funds_to_comm_enabled?: boolean;
  is_enrollment_plan_eligibility_enabled?: boolean;
  is_network_tier_toggle_enabled?: boolean;
  is_federal_limits_from_jvp_enabled?: boolean;
  // Gated in Django only; listed here to keep parity with the backend flag list.
  is_network_preferences_enabled?: boolean;
}

export interface FeatureFlags extends LegacyFeatureFlags, DatadogFeatureFlags {}

const LegacyFeatureFlagDefaults: LegacyFeatureFlags = {
  useContentfulV2: true,
};

export const DatadogFeatureFlagDefaults: DatadogFeatureFlags = {
  is_profile_prefill_enabled: false,
  is_footer_test_enabled: false,
  is_skip_income_enabled: false,
  is_rue_landing_page_enabled: false,
  is_hide_eligibility_questions_enabled: false,
  is_educational_videos_enabled: true,
  is_cancer_insurance_enabled: false,
  is_profile_review_tool_enabled: false,
  is_no_deductible_plans_enabled: false,
  is_ulp_updates_enabled: false,
  is_go_teladoc_mtm_enabled: false,
  is_usersnap_enabled: false,
  is_go_talkspace_mtm_enabled: false,
  is_election_members_enabled: false,
  is_incentives_shortcut_enabled: false,
  is_life_ltc_enabled: false,
  is_medicare_content: false,
  is_legacy_health_text_note_fallback_enabled: false,
  is_hsa_funds_question_enabled: false,
  is_send_hsa_funds_to_comm_enabled: false,
  is_enrollment_plan_eligibility_enabled: false,
  is_network_tier_toggle_enabled: false,
  is_federal_limits_from_jvp_enabled: false,
  is_network_preferences_enabled: false,
};

export const FeatureFlagDefaults = {
  ...LegacyFeatureFlagDefaults,
  ...DatadogFeatureFlagDefaults,
};
